<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">数据中心</Breadcrumb-item>
        <Breadcrumb-item>班主任课耗绩效</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div>
      <Form label-position="left" :label-width="50">
        <Row :gutter="32">
          <Col :span="8" >
            <Form-item label="月份">
              <Row>
                <Col span="11">
                  <Date-picker type="date" format="yyyy-MM" value-format="yyyy-MM" placeholder="起始" v-model="queryParam.queryStartTime" style="width: 100%;" />
                </Col>
                <Col span="2" style="text-align: center">-</Col>
                <Col span="11">
                  <Date-picker type="date" format="yyyy-MM" value-format="yyyy-MM" placeholder="结束" v-model="queryParam.queryEndTime" style="width: 100%;" />
                </Col>
              </Row>
            </Form-item>
          </Col>
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search">搜索
            </Button>
          <Button type="primary" :loading="exportLoading" :disable="exportLoading"
                  @click="exportData">导出
          </Button>
        </Row>
      </Form>
    </div>

    <List ref="dataList" :tableColumns="table" listUrl="/userStudyAdviserLog/class-consumption-statistics"
          :params="queryParam" :onLoading="onLoading" :reload="reload"></List>
  </div>
</template>

<script>
export default {
  data() {
    return {
      exportLoading: false,
      searchLoading: false,
      reload: 0,
      type: 'month',
      queryParam: {
        queryStartTime: '',
        queryEndTime: '',
        studyAdviserId: null
      },
      table: [
        {
          title: '月份',
          align: 'center',
          key: 'monthStr',
          width: 150,
        },
        {
          title: '班主任',
          align: 'center',
          key: 'studyAdviserName',
          width: 150,
        },
        {
          title: '所有学生课耗',
          align: 'center',
          key: 'allConsume',
          width: 150,
        },
        {
          title: '当月新生课耗',
          align: 'center',
          key: 'newStdConsume',
          width: 150,
        },
        {
          title: '当月结课学生课耗',
          align: 'center',
          key: 'overStdConsume',
          width: 150,
        },
        {
          title: '当月1号班主任名下常规生数量',
          align: 'center',
          key: 'stdNumFirstDayOfMonth',
          width: 170,
        },
        {
          title: '未绑定的学生',
          align: 'center',
          key: 'noBindTchNum',
          width: 170,
        },
        {
          title: '当月接收新生数量',
          align: 'center',
          key: 'stdNumNew',
          width: 150,
        },
        {
          title: '当月结课学生数量',
          align: 'center',
          key: 'stdNumOver',
          width: 150,
        },
        {
          title: '课耗绩效',
          align: 'center',
          key: 'performance',
        },
      ]
    }
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    search() {
      this.reload = new Date().getTime()
    },
    onLoading(loading) {
      this.searchLoading = loading
    },
    exportData() {
      this.exportLoading = true
      this.$http.get('/userStudyAdviserLog/class-consumption-statistics-export', {
        responseType: 'arraybuffer',
        params: this.queryParam
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'text/csv'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '班主任课耗绩效.csv'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg)
        }
      }).catch((e) => {
        this.exportLoading = false
      })
    }
  }
}
</script>

<style scoped>
.btn-wrap {
  text-align: right;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// StudyAdviserConsumeList.vue?5a24a10b